<template>
  <v-dialog v-model="dialog" max-width="400" persistent>
    <v-card>
      <v-card-title class="headline">
        <v-icon class="mr-2" color="warning">mdi-alert</v-icon>
        {{ titulo }}
      </v-card-title>

      <v-card-text>
        {{ texto }}
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey darken-1" @click="cancelar">Cancelar</v-btn>
        <v-btn color="primary" @click="aceptar">Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "ConfirmDialog",

    props: {
      titulo: {
        type: String,
        default: "Confirmación",
      },
      texto: {
        type: String,
        default: "¿Está seguro que desea continuar?",
      },
    },

    data() {
      return {
        dialog: false,
        resolvePromise: null,
      }
    },

    methods: {
      show() {
        this.dialog = true
        return new Promise((resolve) => {
          this.resolvePromise = resolve
        })
      },

      cancelar() {
        this.dialog = false
        if (this.resolvePromise) {
          this.resolvePromise(false)
          this.resolvePromise = null
        }
      },

      aceptar() {
        this.dialog = false
        if (this.resolvePromise) {
          this.resolvePromise(true)
          this.resolvePromise = null
        }
      },
    },
  }
</script>
